import { render, staticRenderFns } from "./PlaceholderImage.vue?vue&type=template&id=0a88f4e2&"
import script from "./PlaceholderImage.vue?vue&type=script&lang=js&"
export * from "./PlaceholderImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports